module.exports = __webpack_public_path__ + "static/media/685FoxStNW_2018-06-25_187.181a728f.jpg";